import $ from 'jquery'
import { setupSlideshow, lazyLoad, smoothScroll, menuOverlay, facetReset } from './functions'
import './polyfill'

window.onload = () => {
  setupSlideshow('.product.type-product .product__gallery')
  setupSlideshow('.page-template-100-width .slider-wrapper')
  setupSlideshow('.page-template-design-phases .section__gallery', 'threeItem')
  setupSlideshow('.page-template-custom-pack .section--custom-advantages .section__list', 'twoItem')
  setupSlideshow('.page-template-custom-pack .section--custom-advantages .section__gallery', 'basic')
  setupSlideshow('.page-template-custom-pack .section--custom-showcase .section__gallery', 'variableWidth')

  lazyLoad()
  smoothScroll()
  menuOverlay()
  facetReset()
}



// WEBPACK FOOTER //
// ./src/js/main.js